module.exports = __webpack_public_path__ + "static/media/t6.449d0466.jpg";